import React, { FC } from "react";
import { Description, Icon, IconTypesKeys } from "@evergis/ui";
import { TableInfoDc } from "@evergis/api";

export const AdditionalTableInfo: FC<{ table: TableInfoDc }> = ({ table }) => (
  <Description>
    <div>
      <Icon kind={`geom_${table.geometries[0]}` as IconTypesKeys} />
      {table.rowCount}
    </div>
  </Description>
);
